<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <h1>
      <ion-title>{{'EMAIL_PRINTING' | translate}}</ion-title>
    </h1>
  </ion-toolbar>
</ion-header>
<div class="ion-padding custom-scroll-content"  [attr.aria-label]="newMessage">
  <div class="email-message" [innerHTML]="newMessage"></div>
</div>